import styles from './ChartElements.scss.js';
import { jsx } from 'react/jsx-runtime';

function ChartDiv({
  children,
  height,
  width,
  style = {}
}) {
  return /*#__PURE__*/jsx("div", {
    className: styles.ChartContainer,
    style: {
      height,
      width,
      ...style
    },
    children: children
  });
}

export { ChartDiv };
